/**
 * @generated SignedSource<<6bb827f2ded1d90df8d6c595372dbef4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FellowStatus = "DONE" | "OPEN" | "WONT_DO";
export type CreateJiraIssueInput = {
  assigneeId?: string | null;
  clientMutationId?: string | null;
  description?: string | null;
  dueDate?: string | null;
  issueType: string;
  noteId: string;
  project: string;
  status: FellowStatus;
  title: string;
};
export type IntegrationLinkCreateIssueMutation$variables = {
  input: CreateJiraIssueInput;
};
export type IntegrationLinkCreateIssueMutation$data = {
  readonly createJiraIssue: {
    readonly id: string;
    readonly key: string;
    readonly ok: boolean;
    readonly status: {
      readonly name: string;
      readonly statusCategory: {
        readonly colorName: string;
      };
    };
  } | null;
};
export type IntegrationLinkCreateIssueMutation = {
  response: IntegrationLinkCreateIssueMutation$data;
  variables: IntegrationLinkCreateIssueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationLinkCreateIssueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateJiraIssuePayload",
        "kind": "LinkedField",
        "name": "createJiraIssue",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraIssueStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationLinkCreateIssueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateJiraIssuePayload",
        "kind": "LinkedField",
        "name": "createJiraIssue",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraIssueStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7adcdb05e370e4f9211ff534f9061df6",
    "id": null,
    "metadata": {},
    "name": "IntegrationLinkCreateIssueMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationLinkCreateIssueMutation(\n  $input: CreateJiraIssueInput!\n) {\n  createJiraIssue(input: $input) {\n    ok\n    id\n    key\n    status {\n      name\n      statusCategory {\n        colorName\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3482d7b4aaec4ae177c74f700f6e0bc";

export default node;
